<template>
    <div class="console-body-content-item console-video-log">
        <div class="console-body-content-item-title">
            <span>Logs</span>
        </div>
        <div class="console-body-line">
            <ol class="d-flex flex-row justify-content-start align-self-start flex-wrap list-group list-group-numbered">
                <li class="console-log-item list-group-item"
                    v-for="(item, index) in getLogEvents"
                    :key="index" style="width: 20%;">
                    <div class="console-body-line d-inline text-wrap">
                        <span class="console-body-text">{{ item }}</span>
                    </div>
                </li>
            </ol>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS & EMITS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const getLogEvents = computed(() => {
    return store.getLogEvents;
});

// METHODS

// LIFECYCLE HOOKS
</script>
